<template>
  <div class="content-text">
    <h2 class="title-3 text-left">9.3 eMulti</h2>

    <p>
      Quando o município tem eMulti credenciada ao recebimento de custeio, no
      FNS a ação detalhada é “INCENTIVO FINANCEIRO DA APS - EQUIPES
      MULTIPROFISSIONAIS – EMULTI”. Este recurso pode ser interpretado como está
      no quadro 12.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 12 - DETALHAMENTO DO RECURSO MENSAL DE INCENTIVO FINANCEIRO DA
        APS - EQUIPES MULTIPROFISSIONAIS – EMULTI DO FNS
      </span>
      <table>
        <thead>
          <tr>
            <th>DESCRIÇÃO</th>
            <th>CLASSIFICAÇÃO</th>
            <th>VALOR POR COMPONENTE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fixo de implantação</td>
            <td>-</td>
            <td class="text-right">
              R$
              {{
                valorFixoImplantacao.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr>
            <td>Custeio por atendimento remoto na eMulti</td>
            <td>-</td>
            <td class="text-right">
              R$
              {{
                getValorCusteio('custeio_atendimento_remoto_emulti')
                  .valorFormatado
              }}
            </td>
          </tr>
          <tr>
            <td>Custeio eMulti</td>
            <td>-</td>
            <td class="text-right">
              R$ {{ getValorCusteio('custeio_emulti').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Qualidade indicadores ESB 40h</td>
            <td>BOM</td>
            <td class="text-right">
              R$
              {{
                valorQualidade.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Total</td>
            <td class="text-right">
              R$
              {{
                totalGeral.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>
  </div>
</template>

<script>
import { regras } from '../utils.js'

export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      somaGeralCusteio: 0,
    }
  },
  mounted() {},
  computed: {
    valorFixoImplantacao() {
      const novasEquipes = this.dados.etapa5.equipes
      let somaComponenteFixoImplantacao = 0
      if (novasEquipes != null) {
        let items = novasEquipes.filter((el) => {
          return (
            el.key == 'emulti_ampliada' ||
            el.key == 'emulti_complementar' ||
            el.key == 'emulti_estrategica'
          )
        })
        somaComponenteFixoImplantacao = items.reduce((acc, item) => {
          return acc + item.valor_implantacao * parseInt(item.value)
        }, 0)
      } else {
        somaComponenteFixoImplantacao = 0
      }
      return somaComponenteFixoImplantacao
    },
    valorQualidade() {
      const equipesImplantadas = this.dados.etapa4
      let somaComponenteQualidade = 0
      for (let label in equipesImplantadas) {
        const resultado = regras.qualidade.find((item) => item.label === label)
        if (resultado) {
          if (
            resultado.equipe == 'emulti_ampliada' ||
            resultado.equipe == 'emulti_complementar' ||
            resultado.equipe == 'emulti_estrategica'
          ) {
            const classificacaoEquipe = resultado.classificacao.find(
              (el) => el.tipo === this.classificacao
            )
            let quantidadeDeEquipes = equipesImplantadas[label]
            somaComponenteQualidade +=
              classificacaoEquipe.valor * quantidadeDeEquipes
          }
        }
      }
      return somaComponenteQualidade
    },
    totalGeral() {
      return (
        this.valorFixoImplantacao +
        this.getValorCusteio('custeio_atendimento_remoto_emulti').valor +
        this.getValorCusteio('custeio_emulti').valor +
        this.valorQualidade
      )
    },
  },
  methods: {
    getValorCusteio(key) {
      const item = this.dados.etapa9.equipes.find((el) => {
        return el.key == key
      })
      if (item != undefined) {
        return {
          valor: Number(item.value),
          valorFormatado: item.value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          }),
        }
      } else {
        return 0
      }
    },
  },
}
</script>

<style lang="scss"></style>
